import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { GcTextComponent, IpoTranslatePipe } from '@ip-only/front-end-library';
import { Observable, Subject, takeUntil } from 'rxjs';
import { ImageInstructionComponent } from '../../../../image-instruction/image-instruction.component';
import { SelfInspcetionWrapperData } from '../../report-input-entities';
import { ReportInputsService } from '../../service/report-inputs.service';
import { LoadingSelfInspectionComponent } from '../loading-self-inspection/loading-self-inspection.component';
import { NotApplicableComponent } from '../not-applicable/not-applicable.component';

@Component({
  selector: 'app-report-self-inspection-wrapper',
  templateUrl: './report-self-inspection-wrapper.component.html',
  styleUrl: './report-self-inspection-wrapper.component.scss',
  imports: [
    CommonModule,
    GcTextComponent,
    IpoTranslatePipe,
    NotApplicableComponent,
    LoadingSelfInspectionComponent,
    ImageInstructionComponent,
  ],
})
export class ReportSelfInspectionWrapperComponent implements OnInit, OnDestroy {
  @Input() data: SelfInspcetionWrapperData;
  @Input() isLoading$: Observable<boolean>;
  @Input() showWaring?: boolean = false;

  private readonly cancelSub$ = new Subject<void>();
  showNotApplicable = false;
  isEditMode = false;

  constructor(private readonly reportInputsService: ReportInputsService) {}

  ngOnInit(): void {
    this.subscribeToEditMode();
  }

  ngOnDestroy() {
    this.cancelSub$.next();
  }

  subscribeToEditMode() {
    this.reportInputsService.isEditModeValue$
      .pipe(takeUntil(this.cancelSub$))
      .subscribe((values) => {
        this.isEditMode = values.get(this.data.id) || false;
        this.setIsEditMode();
      });
  }

  setIsEditMode() {
    this.showNotApplicable =
      this.isEditMode || !!this.data.isNotApplicableComment;
  }

  disableIsEditMode() {
    this.reportInputsService.setIsEditModeValue(this.data.id, false);
    this.setIsEditMode();
  }

  get completedString() {
    if (this.data.isNotApplicableComment) {
      return 'reportInput.na';
    } else {
      return 'reportInput.done';
    }
  }

  get completeInfoString() {
    const formattedDate = this.data.lastUpdateAt ?? '';
    const datePart = formattedDate ? `${formattedDate} ` : '';
    return `${datePart}${this.data.updatedBy}`;
  }

  handleMarkAsNA(comment: string) {
    this.disableIsEditMode();
    this.reportInputsService.setMarkAsNAValue(this.data.id, comment);
  }

  handleCancelEditMode() {
    this.disableIsEditMode();
  }
}
